import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiDialog-paper': {
      borderRadius: 32,
    },
  },
  infoContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginBottom: 8,
  },
  info: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'rgba(112, 48, 160, 0.2)',
  },
  infoText: {
    fontWeight: 500,
    textAlign: 'center',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  inputLabel: {
    fontWeight: 500,
    textAlign: 'left',
    alignSelf: 'left',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  formControl: {
    display: 'flex',
    flex: 1,
    minWidth: 120,
    width: '100%',
    backgroundColor: 'rgba(195, 155, 225, 0.2)',
    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: 0,
  },
  select: {
    borderRadius: 16,
    width: '100%',
    minWidth: 360,
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 0,
    },
  },
  description: {
    backgroundColor: 'rgba(112, 48, 160, 0.2)',
    borderRadius: 16,
    height: 140,
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 0,
      borderRadius: 16,
      height: 146,
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
  button: {
    width: '45%',
    borderRadius: 16,
  },
  confirmationContainer: {
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  confirmationInfoContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  confirmationMessage: {
    textTransform: 'uppercase',
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 500,
  },
  confirmationCode: {
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 24,
  },
  confirmationIconContainer: {
    display: 'flex',
    flex: 2,
  },
  confirmationCloseButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    border: 'none',
    margin: 8,
    backgroundColor: 'transparent',
  },
}));
